import { Media } from "types";

export default async function downloadMedia(
  media: Media | null | undefined,
  title: string | null = null
) {
  if (!media) return Promise.reject(null);
  try {
    const hasDownloadTitle = [title, media.mimeType].every(Boolean);
    const link = document.createElement("a");
    link.href = media.url;
    link.download = hasDownloadTitle ? `${title}.${media.mimeType}` : "";
    link.click();
    return Promise.resolve(null);
  } catch (error) {
    return Promise.reject(null);
  }
}
